import axios from "./axios";
import { NINJA_3_ENDPOINT } from "./endpoint";

export const GetChannels = () => {
  return axios.get(`${NINJA_3_ENDPOINT}/api/channels/`);
};
